import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";

export const useGetLayouts = (companyId: number | undefined, reportType: string | undefined) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {data, isLoading, refetch} = useQuery({
        queryKey: ['get-saved-layouts', companyId, reportType],
        queryFn: async () => await apiClient.get('system-reports/layouts', {
            params: {
                reportType: reportType
            }
        }) as string[]
    });

    return {
        data,
        isLoading,
        refetch
    };
};
